var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 48.04,
    height: 46.747,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 811.85 789.99",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 528.45,
    y1: 901.16,
    x2: 392.64,
    y2: 189.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 555.78,
    y1: 891.12,
    x2: 419.95,
    y2: 183.34
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ce9549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#bc6f3b"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 417.47,
    y1: 935.54,
    x2: 405.77,
    y2: 700.81
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#804125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopOpacity: 1,
      stopColor: "#9a522d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#b46336"
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 476.76,
    y1: 890.99,
    x2: 340.9,
    y2: 215.92
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 578.8,
    y1: 1737.87,
    x2: 352.13,
    y2: -341.72
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 452.22,
    y1: 916.15,
    x2: 316.36,
    y2: 204.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 374.43,
    y1: 601.54,
    x2: 398.62,
    y2: 31.62
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#683119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopOpacity: 1,
      stopColor: "#7e4020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#944f28"
    }
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b",
    x1: 388.04,
    y1: 833.63,
    x2: 431.54,
    y2: -232
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 391.62,
    y1: 291.34,
    x2: 456.86,
    y2: 731.71
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 715.81,
    y1: 865.98,
    x2: 582.85,
    y2: 153.92
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 429.52,
    y1: 914.3,
    x2: 293.64,
    y2: 221.46
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 512.95,
    y1: 3137.46,
    x2: 465.91,
    y2: 1976.47
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 527.7,
    y1: 901.54,
    x2: 391.85,
    y2: 189.67
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m312.58 260.88 30.69.05-.03 30.82-30.84-.18.18-30.7zm112.29 175.63c-16.14 4-18.11 25.19-4.69 32.91 6.48 3.72 17.18 2.38 25.21 2.38 6.25.01 22.66.72 27.62-.59 15.25-4 17.87-25.2 4.39-32.87-6.36-3.63-17.1-2.4-25.16-2.4-6.49 0-22.11-.73-27.37.57zm76.89-82.89c-7.96 1.68-13.84 8.02-14.28 17.14-.4 8.49-.8 57.15 1.32 62.37 7.11 17.49 33.57 13.65 34.49-6.32.38-8.39.8-57.35-1.26-62.35-2.73-6.57-10.27-12.95-20.27-10.84zM429.2 378.1c-.31 13.3-2.03 26.17 5.23 33.52 8.12 8.23 21.38 6.37 26.97-1.79 5.63-8.22 3.62-23.47 3.62-34.68 0-14.39 1.72-23.75-8.59-30.32-6.6-4.2-26.53-2.63-35.92-2.63-14.52 0-24.37-2.36-32.4 6.78-7.46 8.49-3.29 21.81 4.73 26.46 8 4.65 25.69 2.13 36.36 2.66zM247.26 195.7c7.77-.64 46.07-.13 56.9-.1 24.29.06 25.48-21.74 16.44-30.39-7.03-6.74-11.95-5.48-23.29-5.48h-57.24c-10.33 0-17.43-.81-23.54 5.24-6.05 5.98-5.29 13.33-5.29 23.54v57.24c0 10.76-1.18 16.91 5.49 23.35 9.94 9.59 30.43 6.97 30.37-16.5-.03-9.04-.5-51.51.16-56.88zm305.41 305.41c-5.09.65-48.06.19-56.89.17-23.1-.08-26.32 19.88-16.49 30.36 6.3 6.71 12.72 5.49 23.34 5.49h57.24c9.78 0 18.02.54 23.58-5.26 5.91-6.18 5.2-13.26 5.2-23.57v-57.24c0-10.6 1.13-16.94-5.47-23.31-5.03-4.85-13.14-7.26-21-3.01-6.57 3.55-9.43 9.62-9.41 19.48.04 10.98.54 48.89-.1 56.9zm-305.45.04-.15-56.94c.25-24.09-21.63-25.53-30.34-16.48-6.76 7.03-5.49 12.05-5.49 23.33v57.24c0 24.96 3.73 28.83 28.83 28.83h57.24c11.36 0 16.29 1.26 23.33-5.49 8.81-8.46 8-30.43-16.49-30.36-10.1.03-50.11.51-56.93-.11zm305.41-305.43c.63 5.9.15 47.37.13 56.86-.02 9.86 2.91 16.01 9.36 19.53 7.58 4.13 16.32 1.98 21.07-3.04 6.72-7.1 5.45-12.01 5.45-23.33V188.5c0-10.21.76-17.49-5.25-23.53-5.98-6.01-13.34-5.24-23.52-5.24h-57.24c-10.78 0-16.81-1.23-23.31 5.47-9.84 10.16-6.64 30.65 16.46 30.36l56.85.16zM312.42 405.24l30.81-.16.05 30.81-30.73.05-.13-30.7zm-20.33-35.77c-18.11 3.17-15.56 18.75-15.54 36.16.01 8.45-.55 46.56.34 51.55 3.2 18.04 23.25 14.62 36.6 14.63 8.23.01 46.63.56 51.47-.42 6.64-1.35 11.51-6 13.35-12.13 1.54-5.15.82-18.27.83-24.39.02-8.5.01-17 0-25.5-.01-15.12 3.82-33.92-12.15-39.19-5.24-1.72-41.54-.95-49.77-.95-6.34 0-19.69-.71-25.13.24zm164.54-108.55 30.7-.01.14 30.63-30.82.22-.02-30.84zm-22.25-35.23c-16.84 4.61-13.62 20.11-13.62 37.47 0 9.97-1.26 43.64.54 50.85 1.53 6.12 6.55 11.25 12.57 12.93 4.13 1.16 70.95 1.23 75.54.19 16.45-3.72 13.89-19.95 13.91-37.22.01-10.18 1.29-43.73-.52-51.31-4.11-17.19-23.5-13.55-37.59-13.56-9.52-.01-44.31-1.14-50.83.65zm-143.95-.11c-16.52 3.9-13.87 20.34-13.87 37.58 0 9.6-1.19 44.47.65 51.24 4.58 16.85 22.82 13.2 37.53 13.2 9.99 0 43.62 1.26 50.84-.55 17.14-4.3 13.57-22.72 13.57-37.14 0-7.96.57-46.28-.46-50.89-3.69-16.45-19.89-13.98-37.19-13.98-10.46 0-43.27-1.31-51.06.53z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.85 395.08c0 42.26-6.76 82.82-19.47 121.03-23.01 70-65.66 131.39-121.5 178.04-25.26 21.29-53.25 39.61-83.51 54.2-54.56 26.76-116.21 41.64-181.38 41.64-125.35 0-237.52-55.28-311.86-142.19-34.45-40.08-60.83-86.9-76.76-138.27C6.1 473.37-.02 434.84-.02 395.08c0-14.27.8-28.21 2.26-41.98 2.4-21.76 6.59-43.07 12.38-63.74 3.37-12.06 7.4-23.79 12.08-35.23 9.5-24.58 21.55-48.07 36.03-70 23.98-37.28 54.55-70.32 89.8-97.72 9.98-7.82 20.44-15.34 31.37-22.06C247.62 23.62 323.91 0 405.98 0c113.3 0 215.78 45.23 289.34 118.19 18.18 17.86 34.6 37.43 48.76 58.43 2.25 2.96 4.18 5.94 6.11 9.07 12.07 18.64 22.38 38.22 31.06 58.73 14.31 33.52 23.81 69.36 28.01 106.79 1.75 14.42 2.57 28.97 2.57 43.86z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.14 347.44c0 4.1 0 8.03-.35 11.96-.5 18.95-2.54 37.4-6.13 55.34-2.71 13.49-6.14 26.48-10.25 39.29-.86 2.89-1.86 5.63-2.9 8.54-2.72 8.01-5.97 15.87-9.21 23.73-6.32 14.51-13.64 28.35-21.66 41.85-6.51 10.41-13.5 20.68-21 30.4-11.61 15.04-24.24 29.03-38.05 41.83-3.58 3.61-7.36 6.83-11.11 10.08-16.54 14.53-34.63 27.33-53.91 38.27-5.63 3.43-11.44 6.51-17.42 9.39-27.8 14.01-57.84 24.43-89.25 30.24-21.31 4.25-43.34 6.5-65.86 6.5-56.33 0-109.39-13.51-156.34-37.24-24.55-12.32-47.27-27.5-67.9-45.09-15.37-13.01-29.53-27.33-42.49-42.7-13.66-16.4-25.77-34.01-36.02-52.62-8.34-14.51-15.52-29.55-21.5-45.25-3.07-7.86-5.81-15.71-8.19-23.75-1.87-6.47-3.75-13.14-5.29-19.79-3.06-12.65-5.46-25.61-6.82-38.96-1.89-13.66-2.75-27.84-2.75-42.01 0-12.46.7-24.76 2.08-36.89a353.1 353.1 0 0 1 10.56-56.03 222.78 222.78 0 0 1 4.61-15.2c1.71-5.46 3.58-10.76 5.64-15.88 2.57-6.83 5.46-13.5 8.54-20.16 4.43-10.25 9.7-20.14 15.35-29.89 2.22-3.93 4.61-7.69 7.01-11.44 8.01-12.81 16.72-24.95 26.27-36.39 15.02-18.28 32.08-34.84 50.51-49.52 7.51-6.15 15.35-11.96 23.74-17.44 1-.67 2.02-1.35 3.07-2.02a313.59 313.59 0 0 1 41.12-23.09C296.29 12 346.8.06 400.05.06c50.68 0 98.8 10.9 142.33 30.56 14.32 6.32 28.15 13.82 41.45 22.21 23.21 14.51 44.54 31.77 63.66 51.24l.34.34c8.37 8.36 16.2 17.25 23.72 26.66 6.15 7.67 12.13 15.87 17.59 24.24 1.87 2.73 3.58 5.29 5.29 8.03a342.47 342.47 0 0 1 26.46 51.6c2.89 6.98 5.61 14.17 8 21.5 4.45 13.15 8.21 26.66 10.93 40.32 2.22 10.58 3.91 21.35 5.12 32.12.34 3.07.69 5.97.86 9.04 1.01 9.75 1.36 19.65 1.36 29.55z",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.11 58.97c-91.31.34-182.77.17-274.07-.36 1-.67 2.02-1.35 3.07-2.02a313.59 313.59 0 0 1 41.12-23.09c65.69-1 131.56-1.67 197.27-2.22 31.23-.31 62.64-.5 93.87-.67 14.32 6.32 28.15 13.82 41.45 22.21-36.52 2.05-73.04 5.98-102.72 6.15z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.57 648.72c-5.63 3.43-11.44 6.51-17.42 9.39-27.8 14.01-57.84 24.43-89.25 30.24-74.23-8.04-148.63-25.62-222.2-30.74-24.55-12.32-47.27-27.5-67.9-45.09 51.68-2.93 104.24 2.38 158.02 10.74 65.72 10.27 131.58 25.45 198.13 25.45 5.96 0 22.36.36 40.62 0z",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.52 526.6c24.74 5.65 83.45 12.82 126.12 31.95-11.61 15.04-24.24 29.03-38.05 41.83-16.21-16.73-54.62-21.17-68.96-24.76-131.05-32.79-266.06-45.26-400.18-57.74-14.17-1.36-41.31-.15-71.16-.67-8.34-14.51-15.52-29.55-21.5-45.25 27.29 2.22 62.12.33 76.8 1.69 132.92 11.96 266.54 23.4 396.92 52.95z",
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.26 142.83c-157.85 14.01-317.07 10.93-474.75 30.57 2.22-3.93 4.61-7.69 7.01-11.44 8.01-12.81 16.72-24.95 26.27-36.39 33.13-1.21 64-.86 85.66-2.07 129.17-7.15 259.41-2.02 388.08-14.16 13.64-1.35 27.48-2.73 41.29-4.95 8.37 8.36 16.2 17.25 23.72 26.66-35 7.17-71.15 9.39-97.28 11.78z",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.78 490.23c16.21-.19 28.15-1.72 36.52-3.93-6.32 14.51-13.64 28.35-21.66 41.85-5.46.33-10.59.52-14.86.52-67.41.67-136.19-20-202.39-28.69-47.96-6.17-94.89-12.82-141.48-25.8-69.98-19.47-139.08-49.53-212.97-49.88-7.86 0-38.4-.34-62.64 4.11-3.06-12.65-5.46-25.61-6.82-38.96 15.85-3.41 30.7-5.29 41.45-6.14 106.5-8.2 204.11 44.56 305.82 66.1 54.44 11.44 110.93 15.71 165.71 24.95 37.54 6.15 75.09 16.38 113.31 15.88z",
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.67 239.84c-2.57-.17-5.12-.35-7.69-.52 1.71-5.46 3.58-10.76 5.64-15.88 2.57-6.83 5.46-13.5 8.54-20.16 35.3 5.12 76.61 2.4 110.06 4.62 77.82 5.29 155.65 10.09 233.45 14.33 100.35 5.65 200.7 10.25 301.2 14.18 4.45 13.15 8.21 26.66 10.93 40.32-126.29-4.94-252.55-10.93-378.85-18.28-94.54-5.46-188.91-11.78-283.28-18.61z",
    style: {
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.07 363.48c-58.19 7.86-118.09 8.05-177.29 8.39 52.9 39.45 132.58 31.24 194.88 42.86-2.71 13.49-6.14 26.48-10.25 39.29-.86 2.89-1.86 5.63-2.9 8.54-9.04-7.68-26.1-14.87-44.37-17.26-75.44-10.07-150.69-16.58-197.79-82.5-8.87-12.63 3.26-28.34 16.57-29.03 63.3-2.74 127.14-2.07 190.11-7.36 18.59-1.53 36.33-4.43 53.75-8.53 1.01 9.75 1.36 19.65 1.36 29.55 0 4.1 0 8.03-.35 11.96-7.84 1.71-15.71 3.08-23.72 4.09z",
    style: {
      fill: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.64,
    y: 155.69,
    width: 451.47,
    height: 422.52,
    rx: 30.51,
    ry: 33.56,
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.75,
    y: 137.15,
    width: 451.47,
    height: 422.52,
    rx: 30.51,
    ry: 33.56,
    style: {
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.23 268.54 30.69.05-.03 30.82-30.84-.18.18-30.7zm112.29 175.63c-16.14 4-18.11 25.19-4.69 32.91 6.48 3.72 17.18 2.38 25.21 2.38 6.25.01 22.66.72 27.62-.59 15.25-4 17.87-25.2 4.39-32.87-6.36-3.63-17.1-2.4-25.16-2.4-6.49 0-22.11-.73-27.37.57zm76.89-82.89c-7.96 1.68-13.84 8.02-14.28 17.14-.4 8.49-.8 57.15 1.32 62.37 7.11 17.49 33.57 13.65 34.49-6.32.38-8.39.8-57.35-1.26-62.35-2.73-6.57-10.27-12.95-20.27-10.84zm-72.56 24.48c-.31 13.3-2.03 26.17 5.23 33.52 8.12 8.23 21.38 6.37 26.97-1.79 5.63-8.22 3.62-23.47 3.62-34.68 0-14.39 1.72-23.75-8.59-30.32-6.6-4.2-26.53-2.63-35.92-2.63-14.52 0-24.37-2.36-32.4 6.78-7.46 8.49-3.29 21.81 4.73 26.46 8 4.65 25.69 2.13 36.36 2.66zm-181.94-182.4c7.77-.64 46.07-.13 56.9-.1 24.29.06 25.48-21.74 16.44-30.39-7.03-6.74-11.95-5.48-23.29-5.48h-57.24c-10.33 0-17.43-.81-23.54 5.24-6.05 5.98-5.29 13.33-5.29 23.54v57.24c0 10.76-1.18 16.91 5.49 23.35 9.94 9.59 30.43 6.97 30.37-16.5-.03-9.04-.5-51.51.16-56.88zm305.41 305.41c-5.09.65-48.06.19-56.89.17-23.1-.08-26.32 19.88-16.49 30.36 6.3 6.71 12.72 5.49 23.34 5.49h57.24c9.78 0 18.02.54 23.58-5.26 5.91-6.18 5.2-13.26 5.2-23.57v-57.24c0-10.6 1.13-16.94-5.47-23.31-5.03-4.85-13.14-7.26-21-3.01-6.57 3.55-9.43 9.62-9.41 19.48.04 10.98.54 48.89-.1 56.9zm-305.45.04-.15-56.94c.25-24.09-21.63-25.53-30.34-16.48-6.76 7.03-5.49 12.05-5.49 23.33v57.24c0 24.96 3.73 28.83 28.83 28.83h57.24c11.36 0 16.29 1.26 23.33-5.49 8.81-8.46 8-30.43-16.49-30.36-10.1.03-50.11.51-56.93-.11zm305.41-305.43c.63 5.9.15 47.37.13 56.86-.02 9.86 2.91 16.01 9.36 19.53 7.58 4.13 16.32 1.98 21.07-3.04 6.72-7.1 5.45-12.01 5.45-23.33v-57.24c0-10.21.76-17.49-5.25-23.53-5.98-6.01-13.34-5.24-23.52-5.24h-57.24c-10.78 0-16.81-1.23-23.31 5.47-9.84 10.16-6.64 30.65 16.46 30.36l56.85.16zM301.07 412.9l30.81-.16.05 30.81-30.73.05-.13-30.7zm-20.33-35.77c-18.11 3.17-15.56 18.75-15.54 36.16.01 8.45-.55 46.56.34 51.55 3.2 18.04 23.25 14.62 36.6 14.63 8.23.01 46.63.56 51.47-.42 6.64-1.35 11.51-6 13.35-12.13 1.54-5.15.82-18.27.83-24.39.02-8.5.01-17 0-25.5-.01-15.12 3.82-33.92-12.15-39.19-5.24-1.72-41.54-.95-49.77-.95-6.34 0-19.69-.71-25.13.24zm164.54-108.55 30.7-.01.14 30.63-30.82.22-.02-30.84zm-22.25-35.23c-16.84 4.61-13.62 20.11-13.62 37.47 0 9.97-1.26 43.64.54 50.85 1.53 6.12 6.55 11.25 12.57 12.93 4.13 1.16 70.95 1.23 75.54.19 16.45-3.72 13.89-19.95 13.91-37.22.01-10.18 1.29-43.73-.52-51.31-4.11-17.19-23.5-13.55-37.59-13.56-9.52-.01-44.31-1.14-50.83.65zm-143.95-.11c-16.52 3.9-13.87 20.34-13.87 37.58 0 9.6-1.19 44.47.65 51.24 4.58 16.85 22.82 13.2 37.53 13.2 9.99 0 43.62 1.26 50.84-.55 17.14-4.3 13.57-22.72 13.57-37.14 0-7.96.57-46.28-.46-50.89-3.69-16.45-19.89-13.98-37.19-13.98-10.46 0-43.27-1.31-51.06.53z",
    style: {
      fill: "url(#m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.28 259.84 30.69.05-.03 30.82-30.84-.18.18-30.7zm112.29 175.63c-16.14 4-18.11 25.19-4.69 32.91 6.48 3.72 17.18 2.38 25.21 2.38 6.25.01 22.66.72 27.62-.59 15.25-4 17.87-25.2 4.39-32.87-6.36-3.63-17.1-2.4-25.16-2.4-6.49 0-22.11-.73-27.37.57zm76.89-82.89c-7.96 1.68-13.84 8.02-14.28 17.14-.4 8.49-.8 57.15 1.32 62.37 7.11 17.49 33.57 13.65 34.49-6.32.38-8.39.8-57.35-1.26-62.35-2.73-6.57-10.27-12.95-20.27-10.84zm-72.56 24.48c-.31 13.3-2.03 26.17 5.23 33.52 8.12 8.23 21.38 6.37 26.97-1.79 5.63-8.22 3.62-23.47 3.62-34.68 0-14.39 1.72-23.75-8.59-30.32-6.6-4.2-26.53-2.63-35.92-2.63-14.52 0-24.37-2.36-32.4 6.78-7.46 8.49-3.29 21.81 4.73 26.46 8 4.65 25.69 2.13 36.36 2.66zm-181.94-182.4c7.77-.64 46.07-.13 56.9-.1 24.29.06 25.48-21.74 16.44-30.39-7.03-6.74-11.95-5.48-23.29-5.48h-57.24c-10.33 0-17.43-.81-23.54 5.24-6.05 5.98-5.29 13.33-5.29 23.54v57.24c0 10.76-1.18 16.91 5.49 23.35 9.94 9.59 30.43 6.97 30.37-16.5-.03-9.04-.5-51.51.16-56.88zm305.41 305.41c-5.09.65-48.06.19-56.89.17-23.1-.08-26.32 19.88-16.49 30.36 6.3 6.71 12.72 5.49 23.34 5.49h57.24c9.78 0 18.02.54 23.58-5.26 5.91-6.18 5.2-13.26 5.2-23.57v-57.24c0-10.6 1.13-16.94-5.47-23.31-5.03-4.85-13.14-7.26-21-3.01-6.57 3.55-9.43 9.62-9.41 19.48.04 10.98.54 48.89-.1 56.9zm-305.45.04-.15-56.94c.25-24.09-21.63-25.53-30.34-16.48-6.76 7.03-5.49 12.05-5.49 23.33v57.24c0 24.96 3.73 28.83 28.83 28.83h57.24c11.36 0 16.29 1.26 23.33-5.49 8.81-8.46 8-30.43-16.49-30.36-10.1.03-50.11.51-56.93-.11zm305.41-305.43c.63 5.9.15 47.37.13 56.86-.02 9.86 2.91 16.01 9.36 19.53 7.58 4.13 16.32 1.98 21.07-3.04 6.72-7.1 5.45-12.01 5.45-23.33v-57.24c0-10.21.76-17.49-5.25-23.53-5.98-6.01-13.34-5.24-23.52-5.24h-57.24c-10.78 0-16.81-1.23-23.31 5.47-9.84 10.16-6.64 30.65 16.46 30.36l56.85.16zM311.12 404.2l30.81-.16.05 30.81-30.73.05-.13-30.7zm-20.33-35.77c-18.11 3.17-15.56 18.75-15.54 36.16.01 8.45-.55 46.56.34 51.55 3.2 18.04 23.25 14.62 36.6 14.63 8.23.01 46.63.56 51.47-.42 6.64-1.35 11.51-6 13.35-12.13 1.54-5.15.82-18.27.83-24.39.02-8.5.01-17 0-25.5-.01-15.12 3.82-33.92-12.15-39.19-5.24-1.72-41.54-.95-49.77-.95-6.34 0-19.69-.71-25.13.24zm164.54-108.55 30.7-.01.14 30.63-30.82.22-.02-30.84zm-22.25-35.23c-16.84 4.61-13.62 20.11-13.62 37.47 0 9.97-1.26 43.64.54 50.85 1.53 6.12 6.55 11.25 12.57 12.93 4.13 1.16 70.95 1.23 75.54.19 16.45-3.72 13.89-19.95 13.91-37.22.01-10.18 1.29-43.73-.52-51.31-4.11-17.19-23.5-13.55-37.59-13.56-9.52-.01-44.31-1.14-50.83.65zm-143.95-.11c-16.52 3.9-13.87 20.34-13.87 37.58 0 9.6-1.19 44.47.65 51.24 4.58 16.85 22.82 13.2 37.53 13.2 9.99 0 43.62 1.26 50.84-.55 17.14-4.3 13.57-22.72 13.57-37.14 0-7.96.57-46.28-.46-50.89C373.7 221.53 357.5 224 340.2 224c-10.46 0-43.27-1.31-51.06.53z",
    style: {
      fill: "#4a2615"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrIcon);
export default __webpack_public_path__ + "static/media/qr_Icon.b2b142b2422bb92cedbabc1ec8b4d464.svg";
export { ForwardRef as ReactComponent };